import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
    {
        path:"/",
        name:"",
        redirect:"/dialogrobot"
    },
    {
        path:"/dialogrobot/:id",
        name:"dialogrobot",
        component:() => import("../views/dialogrobot/dialogrobot.vue")
    }
]

const router = new VueRouter({
  routes
})

export default router
